export const MODULE_SWMS_ACTIVITY = "swms_activity";
export const PERMISSION_ADD_SWMS_ACTIVITY = "sf_swmsactivity_controller_add_swmsactivity";
export const PERMISSION_EDIT_SWMS_ACTIVITY = "sf_swmsactivity_controller_edit_swmsactivity";
export const PERMISSION_VIEW_SWMS_ACTIVITY = "sf_swmsactivity_controller_view_swmsactivity";
export const PERMISSION_DELETE_SWMS_ACTIVITY = "sf_swmsactivity_controller_delete_swmsactivity";
export const MODULE_TIMESHEET_MANAGEMENT = "timesheet-management";
export const PERMISSION_EXPORT_TIMESHEET_FOR_XERO = "sf_timesheet_controller_export_timesheet_for_xero";
export const PERMISSION_EXPORT_TIMESHEET_AS_DISPLAYED = "sf_timesheet_controller_export_timesheet_as_displayed";
